/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST

export const getPaymentCenterList = params => {
  return axios.post(`${base}/payment-center/list`, params)
}

export const getPaymentCenterPreview = params => {
  return axios.post(`${base}/payment-center/preview`, params)
}

export const bankPayment = params => {
  return axios.post(`${base}/payment-center/bank_payment`, params)
}

export const getPaymentCenterBankCode = params => {
  return axios.post(`${base}/payment-center/bank_code`, params)
}

export const updatePaymentCenterCompanyBank = id => {
  return axios.put(`${base}/payment-center/update_company_bank/${id}`)
}

// 手动上传回执，附件仅支持单个文件
export const uploadPaymentReceipt = params => {
  return axios.post(`${base}/payment-center/upload_receipt`, params)
}

// 推送金蝶
export const pushKingdee = id => {
  return axios.post(`${base}/payment-center/push_kingdee/${id}`)
}

// 支付结果附件下载
export const downloadPayResult = (id) => {
  return axios.post(`${base}/payment-center/download_pay_result/${id}`)
}

// 支付异常处理
export const processPayException = id => {
  return axios.post(`${base}/payment-center/process_pay_exception/${id}`)
}



// WEBPACK FOOTER //
// ./src/views/payment-center/payment-center.api.js